































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Job } from '@/@types/LibraryComponent';

@Component
export default class JobMiniCard extends Vue {
  @Prop()
  private job!: Job;

  private switchBackgroundColor(): string {
    if (this.job.isRecruiting) {
      return ''
    } else {
      return 'grey lighten-3'
    }
  }

  private get highPrioritySkills(): Array<string> {
    return this.job.skills.filter((skill, index) => index < 4);
  }

  private get price(): string {
    return (this.job.price * 10000).toLocaleString();
  }

  @Emit('bookmark')
  private bookmark(): string {
    return '';
  }
}
